module.exports = __webpack_public_path__ + "static/media/Lucida Sans Unicode-01.b46c8f7c.svg";